import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
// import SemiPieChart from "../../common/SemiPieChart";
// import ColumnChart from "../../common/ColumnChart";
// import DataTableBase from "../../common/DateTableBase";
import { useNavigate } from "react-router-dom";
import { FaBahtSign } from "react-icons/fa6";
import axios from "axios";
import { API_URL } from "../../../utility";
import { useForm } from "react-hook-form";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../common/Loader";

const ByPoints = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState();
    const [refresh, setRefresh] = useState(2);

    const {register, handleSubmit, reset} = useForm();


    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Profile res : ", res);
            // setStaffList(res?.data?.staffList);
            setUser(res?.data?.user);
            // setUser(res?.data?.billInfo);
            setLoading(false);
        }).catch((err) => {
            console.log("Profile error : ", err);
            setLoading(false);
        })
    }, [refresh])

    const onSubmit = (data) => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.post(`${API_URL}/user/buy-points`, data, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Buy Points : ", res);
            // setStaffList(res?.data?.staffList);
            // setUser(res?.data?.user);
            // setUser(res?.data?.billInfo);
            toast.success(res?.data);
            setRefresh(refresh + 1);
            reset({points: 0});
            setLoading(false);
        }).catch((err) => {
            if(err?.response?.data?.error){
                toast.error(err?.response?.data?.error)
            }
            console.log("Buy Points : ", err);
            setLoading(false);
        })
    }
    
    
    return (
        <div className="overview">
            <ToastContainer autoClose={2500} />
            {loading ? (
                <Loader />
            ) : (
                <>
                    <h1 className="overview-t1">Buy Points</h1>
                    <Row>                
                        <Col md={6}>
                            <div className="overview-card overview-card d-flex">
                                <div className="w-50">
                                    <h6 className="overview-t2">
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="33.75" height="26.25" viewBox="1146.125 205.168 33.75 26.25"><path d="M1170.5 214.543c0-5.178-5.456-9.375-12.188-9.375-6.73 0-12.187 4.197-12.187 9.375 0 2.008.828 3.864 2.225 5.39-.783 1.771-2.077 3.174-2.096 3.194a.468.468 0 0 0 .34.791c2.143 0 3.921-.718 5.199-1.464 1.886.923 4.118 1.464 6.52 1.464 6.73 0 12.187-4.197 12.187-9.375Zm-13.125 5.625v-.954a3.355 3.355 0 0 1-1.838-.665.47.47 0 0 1-.033-.712l.688-.657a.48.48 0 0 1 .594-.042c.226.141.484.218.75.218h1.648c.38 0 .691-.347.691-.773 0-.349-.211-.656-.514-.746l-2.636-.791c-1.09-.327-1.85-1.372-1.85-2.542 0-1.437 1.115-2.604 2.5-2.641v-.945c0-.259.21-.469.468-.469h.938c.259 0 .468.21.468.47v.954a3.35 3.35 0 0 1 1.838.665.47.47 0 0 1 .034.711l-.689.657a.48.48 0 0 1-.593.043 1.406 1.406 0 0 0-.751-.218h-1.647c-.381 0-.692.347-.692.773 0 .348.212.655.514.745l2.637.791c1.09.327 1.85 1.373 1.85 2.543 0 1.437-1.116 2.604-2.5 2.64v.945c0 .26-.21.469-.469.469h-.937a.469.469 0 0 1-.469-.469Zm20.274 7.265c1.398-1.525 2.226-3.382 2.226-5.39 0-3.922-3.134-7.277-7.578-8.676.05.387.078.779.078 1.176 0 6.203-6.308 11.25-14.063 11.25-.631 0-1.249-.045-1.859-.11 1.848 3.37 6.182 5.735 11.235 5.735 2.4 0 4.633-.541 6.52-1.464 1.277.746 3.055 1.464 5.198 1.464a.468.468 0 0 0 .34-.791c-.019-.02-1.314-1.42-2.097-3.194Z" fill="#fff" fill-rule="evenodd" data-name="Icon awesome-comments-dollar"/></svg> */}
                                        <FaBahtSign color="#fff" size="0.6cm" />
                                        <span>Money</span>
                                    </h6>
                                    <h2 className="overview-t3">{(Number((Number(user?.money)).toFixed(2))).toLocaleString()} THB</h2>
                                    {/* <div>
                                        <p className="overview-t4 mb-0 pt-2 mt-4">TOTAL FUND</p>
                                        <p className="overview-t4">0 THB</p>
                                    </div> */}
                                </div>
                                <div className="w-50 card-left-div">
                                    <h2 className="overview-t5">{(Number((Number(user?.points)).toFixed(0))).toLocaleString()}</h2>
                                    <h6 className="overview-t6">
                                        <span>Points</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="26.25" viewBox="1743 390.168 30 26.25"><path d="M1770.023 395.793h-22.335a.937.937 0 1 1 0-1.875h22.5c.517 0 .937-.42.937-.937a2.812 2.812 0 0 0-2.813-2.813h-21.562a3.75 3.75 0 0 0-3.75 3.75v18.75a3.75 3.75 0 0 0 3.75 3.75h23.273c1.642 0 2.977-1.261 2.977-2.812v-15c0-1.551-1.335-2.813-2.977-2.813Zm-2.648 12.188a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z" fill="#fff" fill-rule="evenodd" data-name="Icon awesome-wallet"/></svg>
                                    </h6>
                                </div>
                            </div>
                            
                        </Col>
                        <Col md={6}>
                            <div>
                                {/* <label>By Points</label> */}
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="d-flex mt-1">
                                        <div className="w-25">
                                            <input type="text" {...register("points", {required: true})} className="form-control" placeholder="1 - 999" min={1} max={99} />
                                        </div>
                                        <div className="text-cen pt-1">
                                            <h4 className="pt-1 ps-2">,000</h4>
                                        </div>
                                    </div>
                                    <button className="btn-3 mt-3" type="submit">Buy Points</button>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </>    
            )} 
        </div>
    )
}

export default ByPoints;